import { render, staticRenderFns } from "./CreateLeadVerticalStep2.vue?vue&type=template&id=0c2726bd&"
import script from "./CreateLeadVerticalStep2.vue?vue&type=script&lang=ts&"
export * from "./CreateLeadVerticalStep2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports